<template>
  <v-theme-provider root>
    <v-app>
        
      
        <v-navigation-drawer
          class="text-white"
          :color="getComputedColor"
          style="z-index: 100;"
          app
          :mini-variant="showMini"
          v-model="showMenu"
          width="300"
        >
        <v-list nav
        >
        <v-badge
        v-if="false"
          bordered
          @click.native="openMenu"
          color="error"
          :icon="!showMini ? 'mdi-arrow-expand-left' : 'mdi-arrow-expand-right'"
          overlap 
          tile
          class="d-none d-lg-block mt-0 mr-2"
          style="position: absolute; right: 0; z-index: 9999;"
        >
        </v-badge>
          <v-container class="fill-height fill-width white" fluid 
              v-if="!showMini">
              <v-img 
                src="@/assets/fundo_conduril.png"
                :aspect-ratio="16/9"
                style="
                      display: block;
                      margin-left: auto;
                      margin-right: auto;
                      zoom: 65%;"
                contain
                max-height="100px"
                width="100%"
              />
          </v-container>
          <v-container class="fill-height fill-width" fluid 
              v-else>
              <v-avatar
                size="35px"
                class="ml-n2 mt-2"
              >
                <img
                  alt="Avatar"
                  src="@/assets/fundo_conduril.png"
                >
              </v-avatar>  
          </v-container>
          <v-divider class="mb-2" color="white" v-if="logo_url != null"></v-divider>
            <v-row>
              <v-col cols="12">              
                <div style="color: white !important;" :class="!showMini ? 'text-center mb-n4' : 'text-center mb-n2 ml-n2'">
                  
                    <p class="mt-n6"><br/><span v-if="!showMini" class="text-overline" style="font-size:8px !important;">({{ this.$root.session == undefined ? '' : this.$root.session.email }})</span></p>
                </div>
              </v-col>
              <v-col cols="12" class="text-center mb-4 mt-n4">
                <v-badge  
                  @click="$router.push('/admin/notifications')"
                  style="cursor: pointer;" 
                  overlap                
                  v-if="notifications_to_read.length > 0"
                  color="#DAA520"
                  :content="notifications_to_read.length"
                >
                  <v-icon large color="warning">mdi-bell</v-icon>
                </v-badge>
                <v-icon 
                  @click="$router.push('/admin/notifications')"
                  style="cursor: pointer;" large v-else color="white">mdi-bell</v-icon>
              </v-col>
              
            </v-row>
  
          <v-divider color="white"></v-divider>
          <template v-if="loading">
            <v-skeleton-loader
              v-for="i in items.length"
              v-bind:key="i"
              type="list-item"
            ></v-skeleton-loader>
          </template>
          <template v-for="item in items" v-else>
                <v-list-item :style="'background-color: ' + getColor(item) + ';'" link :to="item.link" :exact="item.exact" :key="item.title" v-if="item.items == 0">
                    <v-list-item-icon>
                      <v-icon >{{item.icon}}</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title style="color: white">{{ item.title }}</v-list-item-title>
                </v-list-item> 
                <v-list-group :style="'background-color: ' + getColor(item) + ';'" :group="item.group" :key="item.title" v-else>
                  <template v-slot:activator>
                    <v-list-item-icon>
                        <v-icon >{{item.icon}}</v-icon>
                      </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title v-text="item.title" style="color: white"></v-list-item-title>
                    </v-list-item-content>
                  </template>
                  
                  <template v-for="child in item.items">
                        <v-list-item :style="'background-color: ' + getColor(child) + ';'" link :to="child.link" :exact="child.exact" :key="child.title" v-if="child.has_permission">
                          <v-list-item-icon>
                            <v-icon >{{child.icon}}</v-icon>
                          </v-list-item-icon>
                          <v-list-item-title v-text="child.title" style="color: white"></v-list-item-title>
                      </v-list-item> 
                      </template>
                </v-list-group> 
          </template>
        </v-list>
  
  
  
        
        
        <template v-slot:append>
          <div v-if="!loading">
          <v-list>
            <v-divider color="white" v-if="showMini"></v-divider>
            <v-list-item>             
              <v-speed-dial
                v-model="fab"
                :direction="'top'"
                :open-on-hover="true"
                :transition="'slide-y-reverse-transition'"
              >
                <template v-slot:activator>
                  <flag :iso="computeLocale" />
                </template>
                <v-btn
                  v-for="language in languages"
                  :key="language.language"
                  fab
                  dark
                  small
                  color="white"
                  @click="changeLanguage(language.language)"
                >
                <flag  :iso="getIsoLanguage(language.language)"/>
                </v-btn>
              </v-speed-dial>           
                <v-btn v-if="!showMini" @click="logout" icon class="mr-2" style="right: 0; position: absolute;">
                  <v-icon>mdi-logout</v-icon>
                </v-btn>
            </v-list-item>
            
            <v-list-item v-if="showMini" :style="'background-color: ' + getColor({color: 'primary'}) + ';'">            
                <v-btn @click="logout" icon class="ml-2" style="left: 0; position: absolute;">
                  <v-icon>mdi-logout</v-icon>
                </v-btn>
            </v-list-item>
  
  
          </v-list>
        </div>
        </template>
          
        
  
      </v-navigation-drawer>
  
      
      <v-main>
        <v-btn
            class="mt-2 ml-1 floating-button primary"
            style="z-index: 99;"
            @click="openMenu"
            dark
            top
            left
            fab
          >
          <v-app-bar-nav-icon></v-app-bar-nav-icon>
        </v-btn>
        <v-progress-linear v-if="loading"
        indeterminate
        class="global-loader"
      ></v-progress-linear>
        <v-container v-on="$listeners" fluid v-if="!loading">
            <v-row class="pa-0 ma-0">
                <v-col offset="0" cols="12" offset-lg="1" lg="10">
                    <router-view></router-view>
                </v-col>
            </v-row>
        </v-container>
      </v-main>
      <v-footer padless>
     
        <v-col
          class="text-center"
          cols="12"
        >
          {{ new Date().getFullYear() }} — <strong :class="this.$root.$vuetify.theme.isDark ? 'white--text' : 'primary--text'">Complaints Management V{{getVersion()}}</strong>
        </v-col>
      </v-footer>
    </v-app>
  </v-theme-provider>
  </template>
  <script>
  import User from "@/api/User.js"
  import Languages from "@/api/Languages.js"
  import Configuration from '@/api/Configuration.js'
  import Notifications from '@/api/Notification.js'

  export default {
    components: {
      
    },
    watch: {
      showMenu: {
        immediate: false,
        handler (val) {
           localStorage['menu-show'] = val;
        },
      },
      showMini: {
        immediate: false,
        handler (val) {
           localStorage['menu-mini'] = val;
        },
      },
      $route: {
          immediate: true,
          handler() {
            if(this.$root.session == undefined){
              return
            }
  
            let theme = this.$root.session.theme;
  
            theme = theme.length == 0 ? this.$themes[0] : theme
            
            this.setTheme(theme);
  
            this.setCssVars();
          }
      },
    },
    data: () => ({
        fab: false,
        dialog: true,
        logo_url: null,
        showMenu: false,
        languages: [],
        showMini: false,
        isRender: true,
        user: {},
        items: [],
        notifications: [],
        notifications_to_read: [],
        loading: true,
        groupSelectedColor: {},
        admins: [
          ['Management', 'mdi-account-multiple-outline'],
          ['Settings', 'mdi-cog-outline'],
        ],
        cruds: [
          ['Create', 'mdi-plus-outline'],
          ['Read', 'mdi-file-outline'],
          ['Update', 'mdi-update'],
          ['Delete', 'mdi-delete'],
        ],
        applicationData:{
          coin: '€'
        }

    }),
    mounted(){
      this.fillBaseData()
    },
    async beforeMount(){
      this.$vuetify.theme.dark = +localStorage['dark-mode'];

      
      await Configuration.list()
      .then(({data}) => {
        this.$store.configurations = data
      }).catch((error) => {
  
        console.error(error);

        localStorage['auth'] = 0;

        this.$router.push('/');
      });
  
      await User.getSession(false).then(async ({data}) =>  {
        this.user = User.getInstance(data);
  
        let theme = data.theme;
  
        theme = theme.length == 0 ? this.$themes[0] : theme
  
        this.setTheme(theme);
  
        this.$root.session = this.user;
  
        
        if(this.user.valid_subscription == false){
          this.$router.push('/invalid')
          return
        }
  
        localStorage['auth'] = 1;
  
        this.loading = false;

        this.setMenu();
  
        this.setCssVars();
  
      }).catch((error) => {
  
        console.error(error);
  
        localStorage['auth'] = 0;
  
        this.$router.push('/');
      });
  
      
  
      this.showMini = localStorage['menu-mini'] == "true";
  
      let showMenu = localStorage['menu-show'];
  
      this.showMenu = showMenu != undefined ? showMenu == "true" : true;
  
      this.showMenu = this.showMenu || !this.$vuetify.breakpoint.mdAndDown;
    },
    computed:{ 
      computeLocale(){
        if(this.$i18n.locale == 'en')
          return 'gb'

        return this.$i18n.locale
      },
      getComputedColor(){
        return this.$root.$vuetify.theme.isDark ? this.$root.$vuetify.theme.themes.dark.primary : this.$root.$vuetify.theme.themes.light.primary
      },
      getEmail(){
        if(this.$root.session == undefined)
          return ''
        return this.$root.session.email
      },
      getUsername(){
        if(this.$root.session == undefined)
          return ''
        return this.$root.session.username
      }
    },
    methods:{
      fillBaseData(){
        Languages.list().then(({data}) => {
          this.languages = data;
        });
        Notifications.list().then(({data}) => {
          this.notifications = data
          this.notifications.forEach(element => {
            if(element.read_at == null)
              this.notifications_to_read.push(element)
          });
        });
      },
      changeLanguage(l){
        this.$i18n.locale = l
        this.setMenu();
      },
      getIsoLanguage(l){
        if(l == 'en')
          return 'gb'

        return l
      },
      getColor(item){
        return this.$root.$vuetify.theme.isDark ? this.$vuetify.theme.themes.dark[item.color] : this.$vuetify.theme.themes.light[item.color]
      },
      checkPermissions(p){
        return this.$root.session.hasPermission(p)
      },
      getVersion(){
              return process.env.VUE_APP_SECRET_VERSION
      },
      setCssVars(){
        let color = this.$vuetify.theme.dark ? this.$vuetify.theme.themes.dark.primaryLight
            : this.$vuetify.theme.themes.light.primaryLight;
  
        this.groupSelectedColor = {
          '--group-selected': color,
        };
      },
      toggleTheme(){
        this.$vuetify.theme.dark = !this.$vuetify.theme.dark;
  
        localStorage['dark-mode'] = Number(this.$vuetify.theme.dark);
      },
      logout() {
        User.logout(this.$root.session.id)
          .then(() => {
            localStorage['auth'] = 0;
  
            this.$router.push('/');
          });
      },
      openMenu(){
  
        if(!this.$vuetify.breakpoint.mdAndDown){
  
          this.showMini = !this.showMini;
  
          return;
        }
  
        this.showMini = false;
  
        this.showMenu = !this.showMenu;
      },
      setMenu() {
        let menu = [{
          title: this.$t('menu.dashboard'),
          icon: "mdi-view-dashboard",
          color: 'secondary',
          has_permission: true,
          exact: true,
          link: "/admin",
          items:[],
        },  
        {
          title: this.$t('menu.complaints_management'),
          icon: "mdi-file-outline",
          has_permission: this.$root.session.hasPermission(["super", "complaints_introduction.read", "categories.read", "states.read"]),
          link: "",
          group:"admin/complaints",
          exact: false,
          items:[
            {
              title: this.$t('menu.complaints_management'),
              icon: "mdi-file-outline",
              has_permission: this.$root.session.hasPermission(["super", "complaints.read"]),
              link: "/admin/complaints/list",
              exact: false,
              items:[],
            },
            {
              title: this.$t('menu.define_complaint_template'),
              icon: "mdi-pencil",
              has_permission: this.$root.session.hasPermission(["super", "complaints_introduction.read"]),
              link: "/admin/complaints/introduction",
              exact: false,
              items:[],
            },
            {
              title: this.$t('menu.categories_management'),
              icon: "mdi-shape",
              has_permission: this.$root.session.hasPermission(["super", "categories.read"]),
              link: "/admin/complaints/categories",
              exact: false,
              items:[],
            },
            {
              title: this.$t('menu.states_management'),
              icon: "mdi-state-machine",
              has_permission: this.$root.session.hasPermission(["super", "states.read"]),
              link: "/admin/complaints/states",
              exact: false,
              items:[],
            } 
          ]
        }, 
        {
          title: this.$t('menu.exports'),
          icon: "mdi-view-dashboard",
          color: 'secondary',
          has_permission: true,
          exact: true,
          link: "/admin/exports",
          items:[],
        },  
        {
        title: this.$t('menu.definitions'),
        icon: "mdi-cog",
        has_permission: this.$root.session.hasPermission(["super", "roles.read", "users.read", "logs.read"]),
        link: "",
        group:"admin/settings",
        exact: false,
        items:[
            {
              title: this.$t('menu.departments_management'),
              icon: "mdi-home-group",
              has_permission: this.$root.session.hasPermission(["super", "departments.read"]),
              link: "/admin/settings/departments",
              exact: false,
              items:[],
            },
            {
              title: this.$t('menu.roles_management'),
              icon: "mdi-shield-account",
              has_permission: this.$root.session.hasPermission(["super", "roles.read"]),
              link: "/admin/settings/roles",
              exact: false,
              items:[],
            },
            {
              title: this.$t('menu.users_management'),
              icon: "mdi-account-multiple",
              has_permission: this.$root.session.hasPermission(["super", "users.read"]),
              link: "/admin/settings/users",
              exact: false,
              items:[],
            },
            {
              title: this.$t('menu.logs'),
              icon: "mdi-paperclip",
              link: "/admin/settings/logs",
              has_permission: this.$root.session.hasPermission(["super", "logs.read"]),
              exact: false,
              items:[],
            },
          ]
        } 
      ];
      
        let fixed_array = []
        menu.forEach(element => {
          fixed_array.push(element)
        });
  
        console.log(fixed_array)
        this.items = fixed_array.filter((item) => {
          console.log(item.has_permission)
          return item.has_permission;
        })

        console.log(this.items)
        console.log(this.$root.session)
      }
    },
  };
  </script>
  <style scoped>
    .floating-button{
      position: fixed !important;
      top: 0 !important;
    }
    
    .v-list-group--active{
      background-color: var(--group-selected);
      border-radius: 4px;
    }
    .fixedBottom {
      position: static !important;
      bottom: 0 !important;
      width: 100%;
    }
    .center {
      display: block;
      margin-left: auto;
      margin-right: auto;
      width: 50%;
    }
  </style>